import { useCallback } from "react";
// This hook is in a separate file to make testing/mocking easier
export const useDummyFetcher = () => useCallback(() => new Promise((resolve) => resolve(null)), []);
